import { renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, resolveComponent as _resolveComponent, withKeys as _withKeys, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_app_form_item = _resolveComponent("app-form-item")!

  return (_openBlock(), _createBlock(_component_app_form_item, {
    label: _ctx.label,
    "control-class": _ctx.controlClass,
    "error-message": _ctx.errorMessage || _ctx.propError
  }, {
    "label-append": _withCtx(() => [
      _renderSlot(_ctx.$slots, "label-append")
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_input, _mergeProps({
        onKeyup: _withKeys(_ctx.onEnter, ["enter"]),
        placeholder: _ctx.label,
        name: _ctx.name,
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event))
      }, _ctx.$attrs, {
        type: _ctx.type,
        inputmode: _ctx.inputmode,
        enterkeyhint: _ctx.enterkeyhint
      }), _createSlots({ _: 2 }, [
        _renderList(_ctx.$slots, (_, name) => {
          return {
            name: name,
            fn: _withCtx((slotData) => [
              _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(slotData)))
            ])
          }
        })
      ]), 1040, ["onKeyup", "placeholder", "name", "modelValue", "type", "inputmode", "enterkeyhint"])
    ]),
    _: 3
  }, 8, ["label", "control-class", "error-message"]))
}